import React from "react";
import clsx from "clsx";
import MuiAvatar, {
  AvatarProps as MuiAvatarProps,
} from "@material-ui/core/Avatar";
import {Skeleton} from "@material-ui/lab";
import useStyles from "./styles";

export function showNameInitialLetters(name: string) {
  const maxInitialLetters = 3;
  return name
    .split(/\s/)
    .map((part: string) => part.substring(0, 1).toUpperCase())
    .filter((v: string) => !!v)
    .slice(0, maxInitialLetters)
    .join("")
    .toUpperCase();
}
type AvatarProps = MuiAvatarProps & {
  name?: string;
  showFallback?: boolean;
  size?: number;
  textSizeRatio?: number;
};

const Avatar = ({
  name,
  showFallback,
  size = 40,
  variant = "circle",
  textSizeRatio = 2.5,
  ...props
}: AvatarProps) => {
  const classes = useStyles({size, textSizeRatio});

  if (!name && showFallback) {
    return (
      <Skeleton
        animation="wave"
        variant={variant === "circle" ? "circle" : "rect"}
        width={size}
        height={size}
      />
    );
  }

  return (
    <MuiAvatar
      {...props}
      variant={variant}
      className={clsx(classes.root, props.className)}
    >
      {name ? showNameInitialLetters(name) : "✷"}
    </MuiAvatar>
  );
};

export default Avatar;
